import React, { useState } from "react";
import DatePicker from "react-datepicker";

import { Button } from "@app/scripts/react-general-components/Button";

const d = new Date();
d.setMinutes(0);
d.setHours(0);

export type Props = {
  label?: string | null;
};

export const Datetime: React.FC<Props> = ({ label }) => {
  const [date, setDate] = useState(d);
  const [open, setOpen] = useState(false);

  return (
    <div className="datetime-picker">
      {open ? (
        <div className="dt-wrapper">
          <label className="_field__label">{label}</label>
          <DatePicker
            selected={date}
            inline
            showTimeInput
            dateFormat="yyyy/MM/dd"
            onChange={(date: Date) => setDate(date)}
          />
          <Button label="Confirm date and time" variant="small" className="fullwidth" />
        </div>
      ) : (
        <div className="_field">
          <input
            onClick={() => setOpen(true)}
            type="text"
            name="recipient_email"
            className="_field__input"
            aria-required="true"
            placeholder={label}
          />
          <label className="_field__label">{label}</label>
        </div>
      )}
    </div>
  );
};
